<template>
	<div ref="scroll">
		<!-- 导航条 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<span class="iconfont" style="float: left;font-size: 14px;margin-right: 10px;">&#xe602;</span>
			<el-breadcrumb-item>账户</el-breadcrumb-item>
			<el-breadcrumb-item class="a">账户余额</el-breadcrumb-item>
		</el-breadcrumb>
		<el-card style="margin-top: 5px;">
			<el-tabs size="mini" v-model="TabName" type="border-card" @tab-click="TabClick">
				<el-tab-pane label="普通账户" name="pt">
					<el-form size="mini" v-loading="loading" label-position="right" v-model="DataForm.pt" label-width="100px">
						<el-row>
							<el-col :span="6">
								<el-form-item label="账户总额">
									<el-input v-model="DataForm.pt.summoney" :readonly="true"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="累计使用额">
									<el-input v-model="DataForm.pt.sumusemoney" :readonly="true"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="账户余额">
									<el-input v-model="DataForm.pt.balance" :readonly="true"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-form-item label="查询条件">
								<el-col :span="24">
									<el-input placeholder="请输入来源单据号" v-model="SearchData.pt.BillsNumber" clearable class="input-with-select" style="width: 200px;margin-right: 10px;"
									 @keyup.enter.native="PtSearch"></el-input>
									<el-input placeholder="请输入备注" v-model="SearchData.pt.Remarks" clearable class="input-with-select" style="width: 200px;margin-right: 10px;"
									 @keyup.enter.native="PtSearch"></el-input>
									<span>日期范围：</span>
									<el-date-picker @change="PtSelect" value-format="yyyy-MM-dd" v-model="SearchData.date" type="daterange"
									 range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期">
									</el-date-picker>
									<el-button type="primary" size="mini" @click="PtSearch" icon="el-icon-search" style="margin-left: 20px;">查询</el-button>
								</el-col>
							</el-form-item>
						</el-row>
					</el-form>
					<el-table size="mini" :max-height="TableHeight" :data="PtData.rows" :show-summary="true" :summary-method="getPtSummaries" v-loading="Tableloading" sidx="F_CreateDate"
					 sord="desc" :header-cell-style="{background:'#5a8642',color:'#ffffff',padding:'0'}">
						<el-table-column prop="type" label="类型" width="70" align="center">
						</el-table-column>
						<el-table-column prop="BillsNumber" label="来源单据号" width="120">
						</el-table-column>
						<el-table-column prop="susemoney" label="收入" width="120" align="right">
							<template slot-scope="scope">
								<span style="color: #00b43d">{{scope.row.susemoney}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="zusemoney" label="支出" width="120" align="right">
							<template slot-scope="scope">
								<span style="color: red">{{scope.row.zusemoney}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="yuemoney" label="余额" width="140" align="right">
							<template slot-scope="scope">
								<span v-if="scope.row.yuemoney<=0" style="color: red">{{scope.row.yuemoney}}</span>
								<span v-else style="color: #00b43d">{{scope.row.yuemoney}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="Remarks" label="备注" min-width="200" align="left">
						</el-table-column>
						<el-table-column prop="cmaker" label="制单人" width="240" align="center">
						</el-table-column>
						<el-table-column prop="cdate" label="收款记录日期" width="160" align="center">
						</el-table-column>
						<el-table-column prop="tijiaodate" label="订单提交日期" width="160" align="center">
						</el-table-column>
						<el-table-column prop="shenhedate" label="订单审核日期" width="160" align="center">
						</el-table-column>
						<!-- <el-table-column label="详情" align="center" width="100">
							<template slot-scope="scope">
								<el-button size="small" style="font-size: 12px;" @click="look(scope.row.f_orderid,scope.row.listtype)" v-if="scope.row.type!='合计:'">
									查看详情
								</el-button>
							</template>
						</el-table-column> -->
					</el-table>
					<!-- 分页 -->
					<!-- <el-pagination layout="prev, pager, next,sizes,total" @size-change="ptSizeChange" @current-change="ptCurrentChange"
					 :page-sizes="[10,50, 100,200, 500]" :current-page="PtData.pagination.page" :page-size="PtData.pagination.rows"
					 :total="PtData.pagination.records">
					</el-pagination> -->
				</el-tab-pane>
				<!-- <el-tab-pane label="配件帐户" name="pj">
					<el-form size="mini" v-loading="loading" label-position="right" v-model="DataForm.pj" label-width="100px">
						<el-row>
							<el-col :span="6">
								<el-form-item label="账户总额">
									<el-input v-model="DataForm.pj.summoney" :readonly="true"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="累计使用额">
									<el-input v-model="DataForm.pj.sumusemoney" :readonly="true"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="账户余额">
									<el-input v-model="DataForm.pj.balance" :readonly="true"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-form-item label="查询条件">
								<el-col :span="24">
									<el-input placeholder="请输入来源单据号" v-model="SearchData.pj.BillsNumber" clearable class="input-with-select" style="width: 200px;margin-right: 10px;"
									 @keyup.enter.native="PjSearch"></el-input>
									<el-input placeholder="请输入备注" v-model="SearchData.pj.Remarks" clearable class="input-with-select" style="width: 200px;margin-right: 10px;"
									 @keyup.enter.native="PjSearch"></el-input>
									<span>日期范围：</span>
									<el-date-picker @change="PjSelect" value-format="yyyy-MM-dd" v-model="SearchData.date" type="daterange"
									 range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期">
									</el-date-picker>
									<el-button type="primary" size="mini" @click="PjSearch" icon="el-icon-search" style="margin-left: 20px;">查询</el-button>
								</el-col>
							</el-form-item>
						</el-row>
					</el-form>
					<el-table size="mini" :max-height="TableHeight" :data="PjData.rows" :show-summary="true" :summary-method="getPjSummaries" v-loading="Tableloading" sidx="F_CreateDate"
					 sord="desc" :header-cell-style="{background:'#5a8642',color:'#ffffff',padding:'0'}">
						<el-table-column prop="type" label="操作类型" width="100" align="center">
						</el-table-column>
						<el-table-column prop="BillsNumber" label="来源单据号" width="150">
						</el-table-column>
						<el-table-column prop="susemoney" label="收入" width="120" align="center">
							<template slot-scope="scope">
								<span style="color: #00b43d">{{scope.row.susemoney}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="zusemoney" label="支出" width="120" align="center">
							<template slot-scope="scope">
								<span style="color: red">{{scope.row.zusemoney}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="yuemoney" label="余额" width="140" align="center">
							<template slot-scope="scope">
								<span v-if="scope.row.yuemoney<=0" style="color: red">{{scope.row.yuemoney}}</span>
								<span v-else style="color: #00b43d">{{scope.row.yuemoney}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="Remarks" label="备注" align="left">
						</el-table-column>
						<el-table-column prop="cmaker" label="制单人" width="100" align="center">
						</el-table-column>
						<el-table-column prop="cdate" label="收款记录日期" width="180" align="center">
						</el-table-column>

						<!-- <el-table-column label="详情" align="center" width="100">
							<template slot-scope="scope">
								<el-button size="small" style="font-size: 12px;" @click="look(scope.row.f_orderid,scope.row.listtype)" v-if="scope.row.type!='合计:'">
									查看详情
								</el-button>
							</template>-->
						</el-table-column> -->
					</el-table>
					<!-- 分页 -->
					<!-- <el-pagination layout="prev, pager, next,sizes,total" @size-change="pjSizeChange" @current-change="pjCurrentChange"
					 :page-sizes="[10,50, 100,200, 500]" :current-page="PjData.pagination.page" :page-size="PjData.pagination.rows"
					 :total="PjData.pagination.records">
					</el-pagination> -->
				</el-tab-pane>
			 
			</el-tabs>
		</el-card>
	</div>
</template>
<script>
	import request from '@/utils/request'

	export default {
		data() {
			return {
				loading: true,
				Tableloading: true,
				TabName: "pt",
				TableHeight:"500px",
				DataForm: {
					pt: {},
					fl: {},
					pj: {},
					wl: {},
					hd: {},
				},
				//普通表格
				PtData: {
					rows: [],
					pagination: {
						//默认每页显示的条数
						rows: 50,
						//默认显示第一页
						page: 1,
						//总数据条数
						records: 10,
						//总页数
						total: 5,
						sidx: "F_CreateDate",
						sord: "desc"
					},
				},
				//返利表格
				FlData: {
					rows: [],
					pagination: {
						//默认每页显示的条数
						rows: 50,
						//默认显示第一页
						page: 1,
						//总数据条数
						records: 10,
						//总页数
						total: 5,
						sidx: "F_CreateDate",
						sord: "desc"
					},
				},
				//配件表格
				PjData: {
					rows: [],
					pagination: {
						//默认每页显示的条数
						rows: 50,
						//默认显示第一页
						page: 1,
						//总数据条数
						records: 10,
						//总页数
						total: 5,
						sidx: "F_CreateDate",
						sord: "desc"
					},
				},
				//物料表格
				WlData: {
					rows: [],
					pagination: {
						//默认每页显示的条数
						rows: 50,
						//默认显示第一页
						page: 1,
						//总数据条数
						records: 10,
						//总页数
						total: 5,
						sidx: "F_CreateDate",
						sord: "desc"
					},
				},
				//活动表格
				HdData: {
					rows: [],
					pagination: {
						//默认每页显示的条数
						rows: 50,
						//默认显示第一页
						page: 1,
						//总数据条数
						records: 10,
						//总页数
						total: 5,
						sidx: "F_CreateDate",
						sord: "desc"
					},
				},
				//搜索条件
				SearchData: {
					date:"",
					begindate: "",
					enddate: "",
					pt: {
						begindate: "",
						enddate: "",
						Remarks: "",
						BillsNumber: "",
						date: "",
					},
					fl: {
						begindate: "",
						enddate: "",
						Remarks: "",
						BillsNumber: "",
						date: "",
						ordercode:""
					},
					pj: {
						begindate: "",
						enddate: "",
						Remarks: "",
						BillsNumber: "",
						date: "",
					},
					wl: {
						begindate: "",
						enddate: "",
						Remarks: "",
						BillsNumber: "",
						date: "",
					},
					hd: {
						begindate: "",
						enddate: "",
						Remarks: "",
						BillsNumber: "",
						date: "",
					},
				},
			};
		},
		created() {
			this.ptdata()
			this.pttable()
			this.TableHeight=(document.documentElement.clientHeight-240)+"px"
			window.onresize = () => {
				this.TableHeight=(document.documentElement.clientHeight-240)+"px"
			}
			//this.TableHeight=(document.documentElement.clientHeight-300)+"px"
		},
		methods: {
			//tab点击事件
			TabClick(tab, event) {
				if (this.TabName == "pt" ) {
					this.ptdata()
					this.pttable()
				} else if (this.TabName == "fl") {
					this.fldata()
					this.fltable()
				} else if (this.TabName == "pj" ) {
					this.pjdata()
					this.pjtable()
				} else if (this.TabName == "wl") {
					this.wldata()
					this.wltable()
				} else if (this.TabName == "hd") {
					this.hddata()
					this.hdtable()
				}
			},


			//普通账户信息获取
			ptdata() {
				this.loading = true
				request({
					url: '/DRPORDERAPI.ashx?a=getptdata',
					method: 'get',
					data: {
						//F_CustomerId: this.$store.state.user.F_CustomerId,
					}
				}).then(res => {
					this.DataForm.pt = res.data
					this.loading = false
				})
			},
			//普通账户表格获取
			pttable() {
				if (this.PtData.pagination.page == null) {
					this.PtData.pagination.page = 1
				}
				this.Tableloading = true
				this.SearchData.pt.date=this.SearchData.date
				this.SearchData.pt.begindate=this.SearchData.begindate
				this.SearchData.pt.enddate=this.SearchData.enddate
				request({
					url: '/DRPORDERAPI.ashx?a=getpttable',
					method: 'get',
					data: {
						pagination: JSON.stringify(this.PtData.pagination),
						queryJson: JSON.stringify(this.SearchData.pt),
						//F_CustomerId: this.$store.state.user.F_CustomerId,
					}
				}).then(res => {
					this.PtData.rows = res.data.rows
					this.PtData.pagination.page = res.data.page
					this.PtData.pagination.records = res.data.records
					this.PtData.pagination.total = res.data.total
					this.Tableloading = false
				})
			},
			//普通账户分页
			ptSizeChange(newSize) {
				this.PtData.pagination.rows = newSize
				this.pttable()
			},
			ptCurrentChange(newPage) {
				this.PtData.pagination.page = newPage
				this.pttable()
			},
			//普通账户选择时间
			PtSelect(e) {
				if (e != null) {
					this.SearchData.begindate = e[0];
					this.SearchData.enddate = e[1];
				} else {
					this.SearchData.begindate = "";
					this.SearchData.enddate = "";
				}
				this.pttable()
			},
			//普通账户搜索
			PtSearch() {
				this.pttable()
			},

			//返利账户信息获取
			fldata() {
				this.loading = true
				request({
					url: '/DRPORDERAPI.ashx?a=getfldata',
					method: 'get',
					data: {
						//F_CustomerId: this.$store.state.user.F_CustomerId,
					}
				}).then(res => {
					this.DataForm.fl = res.data
					this.loading = false
				})
			},
			//返利账户表格获取
			fltable() {
				if (this.FlData.pagination.page == null) {
					this.FlData.pagination.page = 1
				}
				this.Tableloading = true
				this.SearchData.fl.date=this.SearchData.date
				this.SearchData.fl.begindate=this.SearchData.begindate
				this.SearchData.fl.enddate=this.SearchData.enddate
				request({
					url: '/DRPORDERAPI.ashx?a=getfltable',
					method: 'get',
					data: {
						pagination: JSON.stringify(this.FlData.pagination),
						queryJson: JSON.stringify(this.SearchData.fl),
						//F_CustomerId: this.$store.state.user.F_CustomerId,
					}
				}).then(res => {
					this.FlData.rows = res.data.rows
					this.FlData.pagination.page = res.data.page
					this.FlData.pagination.records = res.data.records
					this.FlData.pagination.total = res.data.total
					this.Tableloading = false
				})
			},
			//返利账户分页
			flSizeChange(newSize) {
				this.FlData.pagination.rows = newSize
				this.fltable()
			},
			flCurrentChange(newPage) {
				this.FlData.pagination.page = newPage
				this.fltable()
			},
			//返利账户选择时间
			FlSelect(e) {
				if (e != null) {
					this.SearchData.begindate = e[0];
					this.SearchData.enddate = e[1];
				} else {
					this.SearchData.begindate = "";
					this.SearchData.enddate = "";
				}
				this.fltable()
			},
			//返利账户搜索
			FlSearch() {
				this.fltable()
			},

			//配件账户信息获取
			pjdata() {
				this.loading = true
				request({
					url: '/DRPORDERAPI.ashx?a=getpjdata',
					method: 'get',
					data: {
						//F_CustomerId: this.$store.state.user.F_CustomerId,
					}
				}).then(res => {
					this.DataForm.pj = res.data
					this.loading = false
				})
			},
			//配件账户表格获取
			pjtable() {
				if (this.PjData.pagination.page == null) {
					this.PjData.pagination.page = 1
				}
				this.Tableloading = true
				this.SearchData.pj.date=this.SearchData.date
				this.SearchData.pj.begindate=this.SearchData.begindate
				this.SearchData.pj.enddate=this.SearchData.enddate
				request({
					url: '/DRPORDERAPI.ashx?a=getpjtable',
					method: 'get',
					data: {
						pagination: JSON.stringify(this.PjData.pagination),
						queryJson: JSON.stringify(this.SearchData.pj),
						//F_CustomerId: this.$store.state.user.F_CustomerId,
					}
				}).then(res => {
					this.PjData.rows = res.data.rows
					this.PjData.pagination.page = res.data.page
					this.PjData.pagination.records = res.data.records
					this.PjData.pagination.total = res.data.total
					this.Tableloading = false
				})
			},
			//配件账户分页
			pjSizeChange(newSize) {
				this.PjData.pagination.rows = newSize
				this.pjtable()
			},
			pjCurrentChange(newPage) {
				this.PjData.pagination.page = newPage
				this.pjtable()
			},
			//配件账户选择时间
			PjSelect(e) {
				if (e != null) {
					this.SearchData.begindate = e[0];
					this.SearchData.enddate = e[1];
				} else {
					this.SearchData.begindate = "";
					this.SearchData.enddate = "";
				}
				this.pjtable()
			},
			//配件账户搜索
			PjSearch() {
				this.pjtable()
			},

			//物料账户信息获取
			wldata() {
				this.loading = true
				request({
					url: '/DRPORDERAPI.ashx?a=getwldata',
					method: 'get',
					data: {
						//F_CustomerId: this.$store.state.user.F_CustomerId,
					}
				}).then(res => {
					this.DataForm.wl = res.data
					this.loading = false
				})
			},
			//物料账户表格获取
			wltable() {
				if (this.WlData.pagination.page == null) {
					this.WlData.pagination.page = 1
				}
				this.Tableloading = true
				this.SearchData.wl.date=this.SearchData.date
				this.SearchData.wl.begindate=this.SearchData.begindate
				this.SearchData.wl.enddate=this.SearchData.enddate
				request({
					url: '/DRPORDERAPI.ashx?a=getwltable',
					method: 'get',
					data: {
						pagination: JSON.stringify(this.WlData.pagination),
						queryJson: JSON.stringify(this.SearchData.wl),
						//F_CustomerId: this.$store.state.user.F_CustomerId,
					}
				}).then(res => {
					this.WlData.rows = res.data.rows
					this.WlData.pagination.page = res.data.page
					this.WlData.pagination.records = res.data.records
					this.WlData.pagination.total = res.data.total
					this.Tableloading = false
				})
			},
			//物料账户分页
			wlSizeChange(newSize) {
				this.wlData.pagination.rows = newSize
				this.wltable()
			},
			wlCurrentChange(newPage) {
				this.wlData.pagination.page = newPage
				this.wltable()
			},
			//物料账户选择时间
			WlSelect(e) {
				if (e != null) {
					this.SearchData.begindate = e[0];
					this.SearchData.enddate = e[1];
				} else {
					this.SearchData.begindate = "";
					this.SearchData.enddate = "";
				}
				this.wltable()
			},
			//物料账户搜索
			WlSearch() {
				this.wltable()
			},
			
			//活动账户信息获取
			hddata() {
				this.loading = true
				request({
					url: '/DRPORDERAPI.ashx?a=gethddata',
					method: 'get',
					data: {
						//F_CustomerId: this.$store.state.user.F_CustomerId,
					}
				}).then(res => {
					this.DataForm.hd = res.data
					this.loading = false
				})
			},
			//活动账户表格获取
			hdtable() {
				if (this.HdData.pagination.page == null) {
					this.HdData.pagination.page = 1
				}
				this.Tableloading = true
				this.SearchData.hd.date=this.SearchData.date
				this.SearchData.hd.begindate=this.SearchData.begindate
				this.SearchData.hd.enddate=this.SearchData.enddate
				request({
					url: '/DRPORDERAPI.ashx?a=gethdtable',
					method: 'get',
					data: {
						pagination: JSON.stringify(this.HdData.pagination),
						queryJson: JSON.stringify(this.SearchData.hd),
						//F_CustomerId: this.$store.state.user.F_CustomerId,
					}
				}).then(res => {
					this.HdData.rows = res.data.rows
					this.HdData.pagination.page = res.data.page
					this.HdData.pagination.records = res.data.records
					this.HdData.pagination.total = res.data.total
					this.Tableloading = false
				})
			},
			//活动账户分页
			hdSizeChange(newSize) {
				this.hdData.pagination.rows = newSize
				this.hdtable()
			},
			hdCurrentChange(newPage) {
				this.hdData.pagination.page = newPage
				this.hdtable()
			},
			//活动账户选择时间
			HdSelect(e) {
				if (e != null) {
					this.SearchData.begindate = e[0];
					this.SearchData.enddate = e[1];
				} else {
					this.SearchData.begindate = "";
					this.SearchData.enddate = "";
				}
				this.hdtable()
			},
			//活动账户搜索
			HdSearch() {
				this.hdtable()
			},
			
			
			//表格合计
			getPtSummaries(param) {
				const {
					columns,
					data
				} = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '总计';
						return;
					}
					if(index ===2||index ===3){
						const values = data.map(item => Number(item[column.property]));
						if (!values.every(value => isNaN(value))) {
							sums[index] = values.reduce((prev, curr) => {
								const value = Number(curr);
								if (!isNaN(value)) {
									return prev + curr;
								} else {
									return prev;
								}
							}, 0).toFixed(2);
						} else {
							sums[index] = 'N/A';
						}
					}
				});
				return sums;
			},
			getFlSummaries(param) {
				const {
					columns,
					data
				} = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '总计';
						return;
					}
					if(index ===2||index ===3){
						const values = data.map(item => Number(item[column.property]));
						if (!values.every(value => isNaN(value))) {
							sums[index] = values.reduce((prev, curr) => {
								const value = Number(curr);
								if (!isNaN(value)) {
									return prev + curr;
								} else {
									return prev;
								}
							}, 0).toFixed(2);
						} else {
							sums[index] = 'N/A';
						}
					}
				});
				return sums;
			},
			getPjSummaries(param) {
				const {
					columns,
					data
				} = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '总计';
						return;
					}
					if(index ===2||index ===3){
						const values = data.map(item => Number(item[column.property]));
						if (!values.every(value => isNaN(value))) {
							sums[index] = values.reduce((prev, curr) => {
								const value = Number(curr);
								if (!isNaN(value)) {
									return prev + curr;
								} else {
									return prev;
								}
							}, 0).toFixed(2);
						} else {
							sums[index] = 'N/A';
						}
					}
				});
				return sums;
			},
			getWlSummaries(param) {
				const {
					columns,
					data
				} = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '总计';
						return;
					}
					if(index ===2||index ===3){
						const values = data.map(item => Number(item[column.property]));
						if (!values.every(value => isNaN(value))) {
							sums[index] = values.reduce((prev, curr) => {
								const value = Number(curr);
								if (!isNaN(value)) {
									return prev + curr;
								} else {
									return prev;
								}
							}, 0).toFixed(2);
						} else {
							sums[index] = 'N/A';
						}
					}
				});
				return sums;
			},
			getHdSummaries(param) {
				const {
					columns,
					data
				} = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '总计';
						return;
					}
					if(index ===2||index ===3){
						const values = data.map(item => Number(item[column.property]));
						if (!values.every(value => isNaN(value))) {
							sums[index] = values.reduce((prev, curr) => {
								const value = Number(curr);
								if (!isNaN(value)) {
									return prev + curr;
								} else {
									return prev;
								}
							}, 0).toFixed(2);
						} else {
							sums[index] = 'N/A';
						}
					}
				});
				return sums;
			},
		},
	};
</script>

<style scoped>
	@import "../../font/iconfont.css";

	@font-face {
		font-family: 'iconfont';
		src: url('../../font/iconfont.eot');
		src: url('../../font/iconfont.eot?#iefix') format('embedded-opentype'),
			url('../../font/iconfont.woff2') format('woff2'),
			url('../../font/iconfont.woff') format('woff'),
			url('../../font/iconfont.ttf') format('truetype'),
			url('../../font/iconfont.svg#iconfont') format('svg');
	}

	.iconfont {
		font-family: "iconfont" !important;
		font-size: 12px;
		font-style: normal;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	.a .el-breadcrumb__inner {
		color: #0081ff !important;
		font-weight: 700 !important;
	}
	.el-breadcrumb {
	    font-size: 12px;
	    line-height: 1;
		margin-top: -20px;
	}
	*{
		font-size: 12px;
		font-family:"Microsoft YaHei",微软雅黑,"Microsoft JhengHei",华文细黑,STHeiti,MingLiu
	}
	.el-form-item{
		margin-bottom: 5px !important;
	}
	.el-tabs__item is-top
	{
		font-size: 12px !important;
		
	}
</style>
